(function () {
  angular.module('ticketco/ticketbuyer/contact_organizer')
    .controller('contactOrganizerDialogController', contactOrganizerDialogController);

  function contactOrganizerDialogController(contactOrganizerPersistanceService) {
    var self = this;
    self.sendingMessage = false;

    self.resolve = function (message) {
      self.sendingMessage = true;
      return contactOrganizerPersistanceService.create(message)
        .then(function (res) {
          self.closeThisDialog();
          return res;
        })
        .catch(function (err) {
          self.sendingMessage = false;
          console.error(err);
        });
    };

  }

}());
